/** The Scope 2 basis switch: Location-based or Market-based, written to the address (Q-04).
 *
 * Scope 2 is calculated on two bases and a reader chooses which one the page headlines. Until now
 * the only way was to type `?method=market` into the address, and the page then ignored it
 * (G-Wviewer-05). The choice is **in the address** (`?method=`) so it is linkable and survives a
 * reload, the same as the period; it replaces the entry in history so choosing is not a Back press.
 * The two bases are named and are never added together - each is its own figure.
 *
 * Two native radio inputs in a `radiogroup`: a native control is keyboard-operable (arrows move the
 * choice) and announces its state without any ARIA beyond the group's name. The explanation of what
 * each basis means is behind the Scope 2 tiles' info controls, not here.
 */

import type { Screen } from "../useScreen";
import styles from "./Scope2Basis.module.css";

const CHOICES = [
  { value: "location", label: "Location-based" },
  { value: "market", label: "Market-based" },
] as const;

export function Scope2Basis({ screen }: { screen: Pick<Screen, "method" | "setMethod"> }) {
  return (
    <div className={styles.group} role="radiogroup" aria-label="Scope 2 basis" data-testid="scope2-basis">
      {CHOICES.map((choice) => (
        <label key={choice.value} className={styles.choice}>
          <input
            type="radio"
            name="scope2-basis"
            className={styles.input}
            value={choice.value}
            checked={screen.method === choice.value}
            data-testid={`scope2-basis-${choice.value}`}
            onChange={() => screen.setMethod(choice.value)}
          />
          <span className={styles.face}>{choice.label}</span>
        </label>
      ))}
    </div>
  );
}
